<template>
    <router-link :to="linkToPage" class="list-item wrap" :class="iconStatus.text">
        <p class="details-outil">
            <strong class="type" v-if="outil.type_outil">{{ outil.type_outil.nom }}</strong>
            <b class="marque">{{ outil.marque }}</b> - <span class="modele">{{ outil.modele }}</span>
        </p>
        <div class="tooltip" :class="iconStatus.text">
            <i :class="iconStatus.icon"></i>
            Contrôlé le <strong>{{ outil.date_last_controle | dateFormat }}</strong>
        </div>
    </router-link>
</template>

<script>
    export default {
        data() {
            return {
                isActive: true
            }
        },
        props: {
            outil: {},
        },
        computed: {
            linkToPage: function () {
                return 'outil/' + this.outil.id;
            },

            iconStatus: function () {
                let diff = moment().diff(moment(this.outil.date_last_controle), 'month', true);
                if (diff >= 12) {
                    return {
                        icon: 'icon-error',
                        text: 'error'
                    }
                } else if (diff < 12 && diff >= 11) {
                    return {
                        icon: 'icon-valid',
                        text: 'warning'
                    }
                } else {
                    return {
                        icon: 'icon-valid',
                        text: 'valid'
                    }
                }
            }
        },
        methods: {

        }
    }
</script>




// WEBPACK FOOTER //
// OutilItem.vue?50bdd502